import HospitalMain from './HospitalMain';

export default HospitalMain;
